import React from 'react';
import { LinkContent } from '../partials';
import { LinkProps } from '../Link';
import classNames from 'classnames';

const LinkExternal = ({
  iconAfter = 'AnimatedIconArrowUpRight',
  className,
  ...rest
}: LinkProps) => {
  return (
    <LinkContent
      iconAfter={iconAfter}
      className={classNames('animate', className)}
      {...rest}
    />
  );
};

export default LinkExternal;
